var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4685 12.9143C15.792 13.1731 15.8444 13.6451 15.5857 13.9685L11.5857 18.9685C11.4524 19.1351 11.2545 19.2371 11.0415 19.2489C10.8285 19.2606 10.6205 19.1812 10.4697 19.0303L8.46967 17.0303C8.17678 16.7374 8.17678 16.2626 8.46967 15.9697C8.76256 15.6768 9.23744 15.6768 9.53033 15.9697L10.9378 17.3772L14.4143 13.0315C14.6731 12.708 15.1451 12.6556 15.4685 12.9143Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5857 13.9685C15.8444 13.6451 15.792 13.1731 15.4685 12.9143C15.1451 12.6556 14.6731 12.708 14.4143 13.0315L10.9378 17.3772L9.53033 15.9697C9.23744 15.6768 8.76256 15.6768 8.46967 15.9697C8.17678 16.2626 8.17678 16.7374 8.46967 17.0303L10.4697 19.0303C10.6205 19.1812 10.8285 19.2606 11.0415 19.2489C11.2545 19.2371 11.4524 19.1351 11.5857 18.9685L15.5857 13.9685Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9978 9.25C4.47902 9.25 3.2478 10.4812 3.2478 12V20C3.2478 21.5188 4.47902 22.75 5.9978 22.75H17.9978C19.5166 22.75 20.7478 21.5188 20.7478 20V12C20.7478 10.4812 19.5166 9.25 17.9978 9.25H7.74561V7C7.74561 5.67044 8.18552 4.62075 8.90094 3.90533C9.61635 3.18991 10.666 2.75 11.9956 2.75C13.3252 2.75 14.3749 3.18991 15.0903 3.90533C15.8057 4.62075 16.2456 5.67044 16.2456 7C16.2456 7.41421 16.5814 7.75 16.9956 7.75C17.4098 7.75 17.7456 7.41421 17.7456 7C17.7456 5.32956 17.1855 3.87925 16.1509 2.84467C15.1164 1.81009 13.666 1.25 11.9956 1.25C10.3252 1.25 8.87486 1.81009 7.84028 2.84467C6.80569 3.87925 6.24561 5.32956 6.24561 7V9.25H5.9978ZM5.9978 10.75C5.30745 10.75 4.7478 11.3096 4.7478 12V20C4.7478 20.6904 5.30745 21.25 5.9978 21.25H17.9978C18.6882 21.25 19.2478 20.6904 19.2478 20V12C19.2478 11.3096 18.6882 10.75 17.9978 10.75H5.9978Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartLock);
export default __webpack_public_path__ + "static/media/SmartLock.663df222a4c7aa9379665c6fd22c3f0b.svg";
export { ForwardRef as ReactComponent };